export const UNAUTHORIZED_ROUTES_NAMES = [
  'Login',
  'Registration',
  'WantToRegister',
  'PasswordReset',
  'UserProfile',
  'TeamPage',
  'PrivacyPolicy',
  'PersonalDataDeletion',
];

export const REGISTRATION_ONLY_BY_INVITE = true;
export const GLOBAL_TIMEOUT = 40 * 1000; // 40 seconds

export const BREAKPOINTS = [
  { xs: 0 },
  { sm: 576 },
  { md: 768 },
  { lg: 992 },
  { xl: 1200 },
  { xxl: 1600 },
];

export const HIGHLOAD_THRESHOLD = 100;

export const DESKTOP_SIZE = 1200;
